import React, { useState } from 'react';
import { StyledPlanningDocuments } from './style';
import ParticipationBudgetButton from '../ParticipationBudgetButton';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Divider, Icon, Tooltip } from 'ui';
import UnauthenticatedModal from 'components/Modals/UnauthenticatedModal';
import useJwt from 'utils/useJwt';
import { useUserState } from 'contexts/UserContext';
import { UserGroups } from 'constants/userGroups';

interface ParticipationBudgetProp {
  setIsOpenProjectSearch: React.Dispatch<React.SetStateAction<boolean>>;
}

const TapisDocuments = ({ setIsOpenProjectSearch }: ParticipationBudgetProp) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [showAuthModal, setshowAuthModal] = useState(false);
  const { isTokenActive } = useJwt();
  const user = useUserState();
  const activeRole = user.roles.find((e) => e.id === user.selectedRole);
  const isPhysical = activeRole?.code === UserGroups.authenticated;
  const activeNotPhysicalPerson = isTokenActive() && !isPhysical;
  const closeAuthModal = () => {
    setshowAuthModal(false);
  };

  const handleOpenNotification = () => {
    if (activeNotPhysicalPerson) {
      return;
    }
    if (!isTokenActive()) {
      setshowAuthModal(true);
      return;
    }
    navigate('/main?notification=open');
  };

  const renderDivider = () => (
    <div className="mx-5">
      <Divider />
    </div>
  );

  return (
    <StyledPlanningDocuments>
      <ParticipationBudgetButton
        onClick={() => {
          navigate('/main?document=open');
        }}
      >
        <Tooltip placement="right" hack title={intl.formatMessage({ id: 'planned_documents.documents' })}>
          <Icon icon="files" faBase="fa-regular" />
          <span>{intl.formatMessage({ id: 'planned_documents.document_abbreviation' })} </span>
        </Tooltip>
      </ParticipationBudgetButton>
      {renderDivider()}
      <ParticipationBudgetButton
        onClick={() => {
          navigate('/main?document=open&advanced-search=open');
          setIsOpenProjectSearch(true);
        }}
      >
        <Tooltip placement="right" hack title={intl.formatMessage({ id: 'planned_documents.search_by_document' })}>
          <Icon icon="magnifying-glass" faBase="fa-regular" />
          <span>{intl.formatMessage({ id: 'planned_documents.search_by_document' })} </span>
        </Tooltip>
      </ParticipationBudgetButton>
      {renderDivider()}
      <ParticipationBudgetButton onClick={handleOpenNotification} disabled={activeNotPhysicalPerson}>
        <Tooltip
          placement="right"
          hack
          title={
            activeNotPhysicalPerson
              ? intl.formatMessage({ id: 'planned_documents.you_can_apply_notification_only_with_pysical_role' })
              : intl.formatMessage({ id: 'notification.subscribe' })
          }
        >
          <Icon icon="bell" faBase="fa-regular" />
          <span>{intl.formatMessage({ id: 'notification.subscribe_abbreviation' })}</span>
        </Tooltip>
      </ParticipationBudgetButton>

      <UnauthenticatedModal showModal={showAuthModal} setShowModal={closeAuthModal} />
    </StyledPlanningDocuments>
  );
};

export default TapisDocuments;
